import isServer from 'utils/isServer';

export const getPagePathname = () => {
  let segments;

  if (!isServer()) {
    segments = global.window.location.pathname.split('/');
  }

  // Return the second segment, or an empty string if it doesn't exist
  // Example: http://localhost:3000/new-cars-in-stock/bmw/2-series will extract new-cars-in-stock
  return segments ? segments[1] : '';
};



// WEBPACK FOOTER //
// ./src/utils/getPagePathname/index.js